/**
 * @hidden
 */
export function hasListener(eventName) {
    if (this.v3) {
        return Object.keys(this.$attrs).map(function (name) { return name.toLowerCase(); })
            .some(function (event) { return event.endsWith(eventName.toLowerCase()); });
    }
    else {
        return this.$listeners[eventName];
    }
}
/**
 * @hidden
 */
export function getListeners() {
    if (this.v3) {
        var listeners = {};
        for (var key in (this.$attrs)) {
            if (key.startsWith('on')) {
                listeners[key] = this.$attrs[key];
            }
        }
        return listeners;
    }
    else {
        return this.$listeners;
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-common/dist/es/listeners.js
// module id = 784
// module chunks = 93